/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/market_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M6 10h2v12H6zM9 10h.5v12H9zM11 10h1v12h-1zM13 10h3v12h-3zM17 10h1v12h-1zM20 10h1v12h-1zM22 10h.5v12H22zM24 10h2v12h-2zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
